import kigui from "./kigui";

var swOpenMode;
var isWebView = getUrlVars().mode === "webview" ? true : false;

window.addEventListener("DOMContentLoaded", function () {
  if (isWebView) {
    setWebViewMode();
  } else {
    setNormalMode();
  }
  swOpenMode = document.getElementById("swOpenMode");

  loadSettings();

  var abc = document.querySelectorAll(".abc > .kigui-o-f");
  var i;

  for (i = 0; i < abc.length; i++)
    abc[i].addEventListener("click", openRecipeEvent);

  document
    .getElementById("btnMenu")
    .addEventListener("click", kigui.layout.sidemenu.eventMenuOpen);
  document.getElementById("btnBack").addEventListener("click", btnBackEvent);

  //뒤로 가기 버튼 이벤트
  document.getElementById("btnInfo").addEventListener("click", function () {
    closePagesAll();
    openInfo();
    kigui.layout.sidemenu.eventMenuClose();
  });

  var pageCover = kigui.layout.others.pageCover.getElement();

  pageCover.addEventListener("click", kigui.layout.sidemenu.eventMenuClose);
  pageCover.addEventListener(
    "mousewheel",
    kigui.layout.sidemenu.eventMenuClose
  );
  pageCover.addEventListener("touchmove", kigui.layout.sidemenu.eventMenuClose);

  /*오픈 모드*/
  swOpenMode.addEventListener("change", refleshOpenMode);

  closePagesAll();
  openAbc();
});

function openRecipeEvent() {
  if (swOpenMode.checked === false) this.classList.toggle("show");
}

function refleshOpenMode() {
  var abc = document.querySelector(".abc");

  if (swOpenMode.checked == true) {
    abc.classList.add("open_mode");
  } else {
    abc.classList.remove("open_mode");
  }

  //설정 저장
  if (typeof Storage !== "undefined") {
    localStorage.setItem("openMode", swOpenMode.checked.toString());
  }
}

function loadSettings() {
  if (typeof Storage !== "undefined") {
    var openMode = localStorage.getItem("openMode");

    if (openMode !== null) {
      swOpenMode.checked = openMode === "true";
      refleshOpenMode();
    }
  }
}

function setWebViewMode() {
  var adElem = document.getElementById("ad");
  adElem.parentNode.removeChild(adElem);
  document.getElementById("btnAndroidApp").style.display = "none";
}
function setNormalMode() {
  var adScript = document.createElement("script");
  adScript.async = true;
  adScript.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
  document.getElementsByTagName("head")[0].appendChild(adScript);
}
function getUrlVars() {
  var vars = [],
    hash;
  var hashes = window.location.href
    .slice(window.location.href.indexOf("?") + 1)
    .split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}

function closePagesAll() {
  kigui.layout.contents.getElement().classList.remove("o-abc");
  kigui.layout.contents.getElement().classList.remove("o-info");
}

/**
 *  제작자 설명 부분 읽는 곳
 */
function openInfo() {
  kigui.layout.contents.getElement().classList.add("o-info");
  document.getElementById("btnBack").style.display = "block";
  document.getElementById("btnMenu").style.display = "none";
}
/**
 * 무토 메인 여는 것
 */
function openAbc() {
  kigui.layout.contents.getElement().classList.add("o-abc");
  document.getElementById("btnBack").style.display = "none";
  document.getElementById("btnMenu").style.display = "block";
}

function btnBackEvent() {
  closePagesAll();
  openAbc();
}
